import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { DiscountConfigurationMode } from '../../../shared/modules/vehicle-categories/enums/discount-configuration-mode.enum';
import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';
import { VehicleCategoryFeatureItemDto } from '../../../shared/modules/vehicle-category-feature-items/dtos/vehicle-category-feature-item.dto';
import { VehicleCategoryPricingItemPresetDto } from '../../../shared/modules/vehicle-category-pricing-item-presets';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';

/**
 * Create vehicle category DTO
 */
export class CreateVehicleCategoryDto {
  color?: string | null;
  name!: string;
  @TransformInt()
  vehicleGroupId?: number | null;
  type!: VehicleCategoryTypeEnum;
  availabilityMode!: VehicleCategoryAvailabilityModeEnum;
  notes?: string | null;
  description?: string | null;
  @TransformInt()
  depositPercentage?: number | null;
  @TransformInt()
  depositFlatRate?: number | null;
  @TransformInt()
  standardDiscountPercentage?: number | null;
  discountConfigurationMode?: DiscountConfigurationMode | null;
  @TransformInt()
  excessAmount?: number | null;
  @TransformInt()
  reducedExcessAmount?: number | null;
  @TransformInt()
  minAgeLimit?: number | null;
  @TransformInt()
  youngDriverAgeLimit?: number | null;
  @TransformInt()
  maxAgeLimit?: number | null;
  @TransformInt()
  seniorAgeLimit?: number | null;
  @TransformInt()
  minDrivingYears?: number | null;
  featureItems?: VehicleCategoryFeatureItemDto[] | null;
  pricingTierItems?: PricingTierItemDto[] | null;
  pricingItemPresets?: VehicleCategoryPricingItemPresetDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
